var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-content',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('ntm-block',[_c('formly-form',{attrs:{"form":_vm.form,"model":_vm.model,"fields":_vm.dataFields}}),_c('button',{staticClass:"btn btn-success push-15"},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }